"use cleint";

import { IRemoveQuestion } from "@/@types/exam-question";
import api from "@/services/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

export function useRemoveQuestion() {
  const queryClient = useQueryClient();
  const abortController = useRef<AbortController | null>(null);

  const mutation = useMutation({
    mutationFn: async (id: string) => {
      abortController.current = new AbortController();

      const { data } = await api.delete<IRemoveQuestion>(`/questions/${id}`);

      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/assessment-by-id"],
      });
    },
  });

  return { ...mutation, abort: () => abortController.current?.abort() };
}
